import { chordFor, hits, type Style } from '../style';

/** Highlife: the gankogui bell pattern, bright plucked guitar, walking bass. Ghana's own sound. */
const CHORDS = [[55, 59, 62], [60, 64, 67], [62, 66, 69], [55, 59, 62]]; // G C D G
const BELL_HIGH = 'x.x.x..x.x.x..x.';
const BELL_LOW = '....x.......x...';

export const HIGHLIFE: Style = {
  bpm: 118,
  swing: 0.12,
  play(kit, step, bar, t, len, energy) {
    const chord = chordFor(CHORDS, bar);
    const root = (chord[0] ?? 55) - 12;
    if (hits(BELL_HIGH, step)) kit.bell(t, true);
    if (hits(BELL_LOW, step)) kit.bell(t, false);
    if (hits('x.......x.x.....', step)) kit.kick(t, 0.8);
    if (hits('....x.......x...', step)) kit.clap(t, 0.6);
    if (step % 2 === 0) kit.shaker(t, 0.6 + energy * 0.4);
    if (step === 0) kit.bass(t, root, len * 5);
    if (step === 6) kit.bass(t, root + 7, len * 3);
    if (step === 10) kit.bass(t, root + 12, len * 3);
    if (step === 14) kit.bass(t, root + 11, len * 2);
    // Two interlocking guitar lines, like palm-wine guitar.
    if (hits('x..x..x.x..x..x.', step)) kit.pluck(t, (chord[step % 3] ?? 60) + 12, 0.9);
    if (energy > 0.5 && hits('..x...x...x...x.', step)) kit.pluck(t, (chord[(step + 1) % 3] ?? 64) + 24, 0.5);
  },
};
